import React from "react";

import ChevronLeft from "@material-ui/icons/ChevronLeft";

import {
  Edit,
  choices,
  TextInput,
  SelectInput,
  SimpleForm,
  required,
  TopToolbar,
  ListButton,
  ShowButton,
  useNotify,
  useRefresh,
} from "react-admin";

const StoragesActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} label="Back" icon={<ChevronLeft />} />
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);

export const StoragesEdit = (props) => {
  const validateTypes = choices(
    ["Petri", "Tube", "Plate", "Other"],
    "Please choose one of the values"
  );

  const notify = useNotify();
  const refresh = useRefresh();
  // const redirect = useRedirect();

  const onSuccess = () => {
    notify(`Changes saved`);
    // redirect("/posts");
    refresh();
  };

  return (
    <Edit
      title="Edit Storage"
      undoable={false}
      onSuccess={onSuccess}
      submitOnEnter={true}
      actions={<StoragesActions />}
      {...props}
    >
      <SimpleForm>
        <TextInput
          source="storage"
          validate={required("Storage name is required")}
        />
        <TextInput
          source="freezer"
          validate={required("Freezer is required")}
        />
        <SelectInput
          label="Type"
          source="type"
          choices={[
            { id: "Petri", name: "Petri" },
            { id: "Tube", name: "Tube" },
            { id: "Plate", name: "Plate" },
            { id: "Other", name: "Other" },
          ]}
          validate={validateTypes}
        />
      </SimpleForm>
    </Edit>
  );
};
